import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {ReelsSpeedLevel} from '@gongxigames/framework/slotV2/types';

export const turboControlStore = Store.createStore({
    /**
     * Current reels speed level (turbo level).
     */
    reelsSpeedLevel: Store.signal(ReelsSpeedLevel.normal),
});